import { createReducer } from '@ngrx/store';
import { uniq } from 'lodash-es';

import { produceOn } from 'app/_state/produce-on';

import * as ACTIONS from './entity-list-page.actions';
import { initialState } from './entity-list-page.state';

const _entityListPageReducers = createReducer(initialState,
  //
  produceOn(ACTIONS.ENTITY_LIST_PAGE_ENTITY_EXPANDED, (state, props) => {
    if (!state[props.payload.url]) {
      state[props.payload.url] = {
        expanded_entity_ids: [props.payload.entityId]
      };
    } else {
      const urlState = state[props.payload.url];
      urlState.expanded_entity_ids = uniq(
        [...state[props.payload.url].expanded_entity_ids, props.payload.entityId]
      );
    }
  }),

  produceOn(ACTIONS.ENTITY_LIST_PAGE_ENTITY_COLLAPSED, (state, props) => {
    if (!state[props.payload.url]) {
      state[props.payload.url] = {
        expanded_entity_ids: []
      };
    } else {
      const urlState = state[props.payload.url];
      urlState.expanded_entity_ids = urlState.expanded_entity_ids.filter(ids => !props.payload.entityId);
    }
  })
);

export function entityListPageReducers(state, action) {
  return _entityListPageReducers(state, action);
}
